import { useState, useRef, useEffect, useMemo } from "react";
import { Calendar, momentLocalizer, Views } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import "./index.css";
import { cn } from "../lib/utill";
import MiniCalendar from "./MiniCalendar";
import SlotDetailsModal from "./SlotDetailsModal";
import { useDispatch, useSelector } from "react-redux";
import {
  createSlots,
  deleteAllSchedule,
  deleteSchedule,
  getSlots,
  updateSlots,
} from "../../redux/action/Appointment";
import { Checkbox } from "antd";
import { getWeekDateByDay, stringToDuration, stringToTime } from "../../utils";
import IMAGES from "../../constants/images";
import Popup from "../Popup";
import UpdateSlotDetailsModal from "./UpdateSlotDetailsModal";
import Model from "../Model";
import {
  resetCreateSlot,
  resetDeleteSchedule,
  resetUpdateSlot,
} from "../../redux/slice/Appointment";
import DeleteModel from "../DeleteModel";
import { CalendarClock, CalendarDays } from "lucide-react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
const DragAndDropCalendar = withDragAndDrop(Calendar);

const localizer = momentLocalizer(moment);

export default function CalendarView({ mode }) {
  const containerRef = useRef(null);
  const isSelectingRef = useRef(false);
  const scrollIntervalRef = useRef(null);
  const [startDate, setStartDate] = useState(new Date());
  const [events, setEvents] = useState([]);
  const dispatch = useDispatch();
  const { data, loading } = useSelector((state) => state.GET_SLOTS);
  const { slotData, slotLoading, sloatError } = useSelector(
    (state) => state.CREATE_SLOTS
  );
  const { updateSlotData, updateSlotLoading, updateSlotError } = useSelector(
    (state) => state.UPDATE_SLOT
  );
  const { deleteScheduleData, deleteScheduleLoading, deleteScheduleError } =
    useSelector((state) => state.DELETE_SCHEDULE);
  const [current, setCurrent] = useState(new Date());
  const [view, setView] = useState("week");
  const [title, setTitle] = useState(null);
  const [description, setDescription] = useState(null);
  const [icon, setIcon] = useState(null);
  const [show, setShow] = useState(false);
  const [selectedSlot, setSelectedSlot] = useState({
    start: "",
    end: "",
  });
  const [highlightedSlot, setHighlightedSlot] = useState(null);
  const [showSlotDetails, setShowSlotDetails] = useState(false);
  const calendarRef = useRef(null);
  const [sameForAllWeek, setSameForAllWeek] = useState(true);
  const [sameForAllMonth, setSameForAllMonth] = useState(false);
  const [selectedDay, setselectedDay] = useState(null);
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [editOpen, setEditOpen] = useState(false);
  const [editMsg, setEditMsg] = useState(null);
  const [editDate, setEditDate] = useState(null);
  const [editDialog, setEditDialog] = useState(false);
  const [editSelectedDuration, setEditSelectedDuration] = useState(0);
  const [editSelectedModes, setEditSelectedModes] = useState([]);
  const [editSlotId, setEditSlotId] = useState(null);
  const [editDayOfWeek, setEditDayOfWeek] = useState(null);
  const [showDeleteConfirmation, setshowDeleteConfirmation] = useState(false);
  const calendarContainerRef = useRef(null); // Create a ref for the scrollable calendar container
  const [clickPosition, setClickPosition] = useState({ x: 0, y: 0 });
  const modalRef = useRef(null);
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const [lastInteractedEventId, setLastInteractedEventId] = useState(null);

  const [deleteAllConfirmation, setDeleteAllConfirmation] = useState(false);
  const [isSelecting, setIsSelecting] = useState(false);

  const highlightEvent = highlightedSlot
    ? [
      {
        id: "selection-highlight",
        start: highlightedSlot.start,
        end: highlightedSlot.end,
        title: "New Slot",
        isHighlight: true,
      },
    ]
    : [];

  const allEvents = [...events, ...highlightEvent];

  const handleSelectSlot = (slotInfo) => {
    const { start, end } = slotInfo;

    // Check if any event overlaps with the selected time slot
    const isSlotOccupied = allEvents.some((event) => {
      const eventStart = new Date(event.start);
      const eventEnd = new Date(event.end);

      // Check if the selected time slot overlaps with an existing event
      return (
        (start >= eventStart && start < eventEnd) ||
        (end > eventStart && end <= eventEnd) ||
        (start <= eventStart && end >= eventEnd)
      );
    });

    console.log(
      "Selected slot:",
      moment(start).format("HH:mm"),
      "-",
      moment(end).format("HH:mm")
    );

    // if (isSlotOccupied) {
    //   alert("This time slot is already taken");
    //   return;
    // }

    // Continue with your existing functionality if the slot is free
    setHighlightedSlot(slotInfo);
    const scheduleDate = moment(start).format("YYYY-MM-DD");
    const startTime = moment(start).format("HH:mm");
    const endTime = moment(end).format("HH:mm");
    const day = moment(start).format("dddd").toUpperCase(); // e.g., "WEDNESDAY"

    setSelectedSlot({
      start: startTime,
      end: endTime,
      scheduleDate,
    });

    setselectedDay(day);
    setShowSlotDetails(true);
    setStartTime(startTime);
    setEndTime(endTime);
  };

  const handleSaveSlot = (slotInfo) => {
    const { duration, consultationModes, applyToDays, scheduleDate } = slotInfo;
    const startHour = moment(selectedSlot.start).format("HH:mm");
    const endHour = moment(selectedSlot.end).format("HH:mm");
    console.log("info=====>", selectedSlot);

    // Format modes
    const formattedModes = consultationModes
      .map((mode) => mode.replace("-", "_").toUpperCase())
      .join(",");

    // Build the schedule array
    const scheduleArray = applyToDays.map((day) => ({
      dayOfWeek: day,
      startTime: `${selectedSlot.start}:00`,
      endTime: `${selectedSlot.end}:00`,
      slotDuration: duration,
      modes: formattedModes,
      scheduleDate: getWeekDateByDay(day, scheduleDate),
    }));

    console.log("scheduleArray", scheduleArray);

    if (slotInfo?.consultationModes?.length > 0) {
      let payload = {
        applyAllWeeks: sameForAllWeek,

        dailyAvailiblity: scheduleArray,
      };

      dispatch(createSlots(payload)).then(() => {
        dispatch(getSlots());
        setShowSlotDetails(false);
        setHighlightedSlot(null);
      });
    } else {
      alert("Please select mode");
    }
  };

  const handleEditSlot = (slotInfo) => {
    console.log("selectedSlot", selectedSlot);
    let start = moment(selectedSlot.start).format("hh:mm");
    let date = moment(selectedSlot.start).format("YYYY-MM-DD");
    let end = moment(selectedSlot.end).format("hh:mm");

    const dateS = new Date(selectedSlot.start);
    const dateE = new Date(selectedSlot.end);

    // console.log(date.toLocaleString("en-IN", { timeZone: "Asia/Kolkata" }));

    let newStart = dateS.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
    });
    let newEnd = dateE.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
    });

    const formattedModes = slotInfo.consultationModes
      .map((mode) => mode.replace("-", "_").toUpperCase())
      .join(",");
    let payload = {
      applyAllWeeks: sameForAllWeek,
      dailyAvailiblity: [
        {
          scheduleId: editSlotId,
          slotDuration: slotInfo.duration,
          modes: formattedModes,
          dayOfWeek: selectedDay,
          startTime: moment(newStart, "DD/MM/YYYY HH:mm:ss A").format("HH:mm"),
          endTime: moment(newEnd, "DD/MM/YYYY HH:mm:ss A").format("HH:mm"),
          scheduleDate: date,
        },
      ],
    };
    setEditDialog(false);

    dispatch(updateSlots(payload));
  };

  const eventStyleGetter = (event) => {
    return {
      style: {
        cssText: `
        background-color: ${event.color} !important;
        border-radius: 12px !important;
        color: #333;
        border: none;
        display: block;
        width: 100%;
        height: 100%;
      `,
      },
    };
  };

  function CustomDateHeader({ date }) {
    const now = current;
    const isToday = moment(date).isSame(now, "day");

    return (
      <div className={`custom-header ${isToday ? "today" : ""}`}>
        <div>{moment(date).format("ddd")}</div>
        <div>{moment(date).format("D")}</div>
      </div>
    );
  }

  const EventComponent = ({ event }) => {
    const modes = event.consultationModes || [];

    return (
      <div
        className="flex h-full w-full flex-col p-0"
        data-schedule-id={event.scheduleId}
        onClick={(e) => {
          setSelectedSlot({
            start: event.start,
            end: event.end,
          });
          setEditSelectedDuration(event.duration);
          setEditSelectedModes(event.consultationModes);
          setEditSlotId(event.scheduleId);
          const dayOfWeek = moment(event.start).format("dddd").toUpperCase();
          setShowSlotDetails(false);
          setselectedDay(dayOfWeek);
          setEditOpen(true);
          // setEditMsg()
          const formattedStartTime = moment(event.start).format("h:mm A");
          const formattedEndTime = moment(event.end).format("h:mm A");
          const formattedDay = moment(event.start).format("dddd"); // e.g., Wednesday
          const formattedDate = moment(event.start).format("D MMMM YYYY"); // e.g., 19 June 2025

          const message = `${formattedStartTime} - ${formattedEndTime} | ${formattedDay}, ${formattedDate}`;
          setEditMsg(message);
          setEditDate(moment(event.start).format("YYYY-MM-DD"));
          //console.log(event);
        }}
      >
        <div className="mb-1 text-center   font-normal mt-3 text-[#0B4F9F] font-poppins text-[12px] mb-2">
          {event.title === "New Slot" ? null : (
            <>
              {" "}
              {moment(event.start).format("HH:mm")} -{" "}
              {moment(event.end).format("HH:mm")}
            </>
          )}
        </div>
        <center>
          {event.title === "New Slot" ? null : (
            <>
              <div className="flex justify-center items-center space-x-1 bg-[#0B4F9F] w-min h-min px-1 py-1 rounded-full">
                {modes.includes("audio") && (
                  <span className="flex h-3 w-3 items-center justify-center rounded-full bg-[#0B4F9F] text-white text-xs">
                    <img
                      src={IMAGES.voice_call}
                      alt={"icon"}
                      className="w-3 h-3"
                    />
                  </span>
                )}
                {modes.includes("video") && (
                  <span className="flex h-4 w-4 items-center justify-center rounded-full bg-[#0B4F9F] text-white text-xs">
                    <img src={IMAGES.video} alt={"icon"} className="w-3 h-3" />
                  </span>
                )}
                {modes.includes("chat") && (
                  <span className="flex h-4 w-4 items-center justify-center rounded-full bg-[#0B4F9F] text-white text-xs">
                    <img
                      src={IMAGES.chat_new}
                      alt={"icon"}
                      className="w-3 h-3"
                    />
                  </span>
                )}
                {modes.includes("in-person") && (
                  <span className="flex h-4 w-4 items-center justify-center rounded-full bg-[#0B4F9F] text-white text-xs">
                    <img
                      src={IMAGES.user_filled}
                      alt={"icon"}
                      className="w-3 h-3"
                    />
                  </span>
                )}
              </div>
            </>
          )}
        </center>
        {event.title === "New Slot" ? null : (
          <span className="text-center text-[#334155] text-[12px] font-poppins font-normal mt-2">
            ({stringToDuration(event.title)})
          </span>
        )}
      </div>
    );
  };

  const deleteAllScheduleConfirmation = () => {
    setDeleteAllConfirmation(true);
    setTitle("Are you sure you want to delete all schedule?");
    setIcon(IMAGES.delete_unavailable);
    setDescription("Do you want to delete all schedule?");
  };

  // Handle the event drop to update start and end time
  const handleEventDrop = ({ event, start, end }) => {
    // Check for overlap
    const hasOverlap = events.some((ev) => {
      if (ev.scheduleId === event.scheduleId) return false; // Skip the event being moved

      const existingStart = new Date(ev.start);
      const existingEnd = new Date(ev.end);

      return (
        (start >= existingStart && start < existingEnd) ||
        (end > existingStart && end <= existingEnd) ||
        (start <= existingStart && end >= existingEnd)
      );
    });

    if (hasOverlap) {
      alert("This time slot overlaps with an existing slot.");
      return;
    }

    // No overlap, proceed with updating
    const updatedEvent = { ...event, start, end };

    setEvents((prevEvents) =>
      prevEvents.map((ev) =>
        ev.scheduleId === event.scheduleId ? updatedEvent : ev
      )
    );

    setLastInteractedEventId(event.scheduleId);
    setSelectedSlot({ start, end });
    setEditSelectedDuration(event.duration);
    setEditSelectedModes(event.consultationModes);
    setEditSlotId(event.scheduleId);

    const dayOfWeek = moment(start).format("dddd").toUpperCase();
    setShowSlotDetails(false);
    setselectedDay(dayOfWeek);
    setEditDialog(true);

    const formattedStartTime = moment(start).format("h:mm A");
    const formattedEndTime = moment(end).format("h:mm A");
    const formattedDay = moment(start).format("dddd");
    const formattedDate = moment(start).format("D MMMM YYYY");

    const message = `${formattedStartTime} - ${formattedEndTime} | ${formattedDay}, ${formattedDate}`;
    setEditMsg(message);
  };

  const getMySlotsData = () => {
    dispatch(getSlots()).then(() => {
      dispatch(getSlots());
    });
  };

  useEffect(() => {
    getMySlotsData();
  }, [updateSlots]);

  const convertScheduleToDaily = (weeklyData) => {
    const daily = {};

    Object.entries(weeklyData).forEach(([_, schedules]) => {
      schedules.forEach((schedule) => {
        const dateStr = schedule.startDate;
        if (!moment(dateStr, "YYYY-MM-DD", true).isValid()) return;

        if (!daily[dateStr]) daily[dateStr] = [];
        daily[dateStr].push(schedule);
      });
    });

    return daily;
  };
  const dailySchedule = useMemo(() => {
    if (mode === "availability" && data?.dailySchedule) {
      return convertScheduleToDaily(data.dailySchedule);
    }
    return {};
  }, [data, mode]);

  useEffect(() => {
    if (mode === "availability" && dailySchedule) {
      const newEvents = [];

      Object.entries(dailySchedule).forEach(([dateStr, schedules]) => {
        const targetDate = moment(dateStr, "YYYY-MM-DD", true);
        if (!targetDate.isValid()) return;

        schedules.forEach((schedule) => {
          const [startHour, startMinute] = schedule.startTime
            .split(":")
            .map(Number);
          const [endHour, endMinute] = schedule.endTime.split(":").map(Number);

          const start = moment(targetDate)
            .hour(startHour)
            .minute(startMinute)
            .toDate();
          const end = moment(targetDate)
            .hour(endHour)
            .minute(endMinute)
            .toDate();

          const color =
            schedule.slotDuration === 15
              ? "#BDFFE1"
              : schedule.slotDuration === 30
                ? "#BDDBFF"
                : schedule.slotDuration === 45
                  ? "#FFBDDB"
                  : schedule.slotDuration === 60
                    ? "#FFE1BD"
                    : "#BBDEFB";

          newEvents.push({
            scheduleId: schedule.scheduleId,
            id: `${schedule.scheduleId}-${dateStr}`,
            title: `${schedule.startTime} - ${schedule.endTime} (${schedule.slotDuration} min)`,
            start,
            end,
            duration: schedule.slotDuration,
            consultationModes: schedule.modes
              .split(",")
              .map((m) => m.replace("_", "-").toLowerCase()),
            color,
          });
        });
      });

      setEvents(newEvents);
    }
  }, [mode, dailySchedule]);

  useEffect(() => {
    if (updateSlotData) {
      if (updateSlotData === "Schedule Updated") {
        getMySlotsData();

        setShow(true);

        setTitle("Availability Updated");
        setDescription("Your availability updated successfully.");
        setIcon(IMAGES.slot_success);
      }
    }
    if (updateSlotError) {
      setShow(true);

      setTitle("Availability Updation Failed");
      setDescription(updateSlotError.payload);
      setIcon(IMAGES.slot_error);
    }
  }, [updateSlotData, updateSlotError]);

  useEffect(() => {
    if (slotData) {
      if (slotData === "Schedule Updated") {
        setShow(true);

        setTitle("Availability Created");
        setDescription("Your availability created successfully.");
        setIcon(IMAGES.profile_success);
      }
    }
    if (sloatError) {
      setShow(true);

      setTitle("Availability Creation Failed");
      setDescription(sloatError.payload);
      setIcon(IMAGES.slot_error);
    }
  }, [slotData, sloatError]);

  useEffect(() => {
    if (!lastInteractedEventId || !calendarContainerRef.current) return;

    const calendarNode = calendarContainerRef.current;
    const resizedEventNode = calendarNode.querySelector(
      `.rbc-event[data-schedule-id="${lastInteractedEventId}"]`
    );

    if (resizedEventNode && calendarNode) {
      const eventRect = resizedEventNode.getBoundingClientRect();
      const containerRect = calendarNode.getBoundingClientRect();

      const isOutOfView =
        eventRect.top < containerRect.top ||
        eventRect.bottom > containerRect.bottom;

      if (isOutOfView) {
        resizedEventNode.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }

    setLastInteractedEventId(null);
  }, [events]);

  useEffect(() => {
    if (deleteScheduleData) {
      if (deleteScheduleData) {
        setShow(true);
        getMySlotsData();
        setTitle("Schedule deleted successfully.");
        setDescription("Your schedule deleted successfully.");
        setIcon(IMAGES.slot_success);
      }
    }
    if (deleteScheduleError) {
      setShow(true);
      console.log("deleteScheduleError", deleteScheduleError);
      setTitle("Schedule deletetion Failed");
      setDescription(
        deleteScheduleError?.payload
          ? deleteScheduleError.payload
          : "Something went wrong"
      );
      setIcon(IMAGES.slot_error);
    }
  }, [deleteScheduleData, deleteScheduleError]);

  const isPastDate = (date) => {
    const now = new Date();
    return date < now.setHours(0, 0, 0, 0); // Only dates before today
  };

  const handleContainerClick = (e) => {
    setIsSelecting(true);
    const container = calendarContainerRef.current;
    if (!container) return;

    const rect = container.getBoundingClientRect();
    const relativeX = e.clientX - rect.left;
    const relativeY = e.clientY - rect.top;

    console.log("Click position relative to container:", {
      x: relativeX,
      y: relativeY,
    });
    console.log("Click position relative to viewport:", {
      x: e.clientX,
      y: e.clientY,
    });

    setClickPosition({ x: relativeX, y: relativeY });
  };
  const CustomToolbar = (toolbar) => {
    const goToBack = () => {
      const today = new Date();
      const prev = new Date(toolbar.date);
      prev.setDate(prev.getDate() - 7);

      // if (prev < today.setHours(0, 0, 0, 0)) {

      //   return;
      // }
      toolbar.onNavigate("PREV");
    };

    const goToNext = () => {
      toolbar.onNavigate("NEXT");
    };

    const goToToday = () => {
      toolbar.onNavigate("TODAY");
    };

    return (
      <div className="rbc-toolbar">
        <span className="rbc-btn-group">
          <button onClick={() => goToBack()} className="font-poppins">
            Prev
          </button>
          <button onClick={goToToday} className="font-poppins">
            Today
          </button>
          <button onClick={goToNext} className="font-poppins">
            Next
          </button>
        </span>
        <span className="rbc-toolbar-label font-poppins">{toolbar.label}</span>
      </div>
    );
  };

  useEffect(() => {
    const calendarContent = () =>
      calendarContainerRef.current?.querySelector(".rbc-time-content");

    const isSelectingRef = { current: false };

    const handleMouseMove = (e) => {
      if (!isSelectingRef.current) return;

      const content = calendarContent();
      if (!content) return;

      const rect = content.getBoundingClientRect();
      const mouseY = e.clientY;
      const edgeThreshold = 40;
      const scrollSpeed = 15;

      // Scroll down
      if (mouseY > rect.bottom - edgeThreshold) {
        content.scrollTop += scrollSpeed;
      }

      // Scroll up
      if (mouseY < rect.top + edgeThreshold) {
        content.scrollTop -= scrollSpeed;
      }
    };

    const handleMouseDown = () => {
      isSelectingRef.current = true;
    };
    const handleMouseUp = () => {
      isSelectingRef.current = false;
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mousedown", handleMouseDown);
    document.addEventListener("mouseup", handleMouseUp);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mousedown", handleMouseDown);
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, []);

  return (
    <div className="flex flex-col lg:flex-row gap-4 relative">
      <div className="flex-1">
        <div className="mb-3 flex items-center gap-2.5 mt-1">
          <div className="flex items-center justify-center w-[32px] h-[32px] rounded-lg bg-[#EFF6FF] text-[#2563EB] flex-shrink-0">
            <CalendarClock size={16} />
          </div>
          <div>
            <h1 className="text-[#171717] text-base font-semibold font-poppins mb-0">
              Set Your Weekly Consultation Hours
            </h1>
            <p className="text-[#64748B] text-xs font-normal font-poppins mt-0.5 mb-0">
              Drag on the calendar to select available time slots, then choose
              your preferred slot length and consultation modes.
            </p>
          </div>
        </div>

        <DndProvider backend={HTML5Backend}>
          <div
            ref={calendarContainerRef}
            onClick={handleContainerClick}
            // onMouseDown={handleContainerClick}
            className="w-full"
            style={{
              position: "relative",
            }}
          >
            {" "}
            {/* Attach ref here */}
            {loading ? null : (
              <DragAndDropCalendar
                min={new Date(1970, 0, 1, 0, 0, 0)} // Full 24h from 12:00 AM
                max={new Date(1970, 0, 1, 23, 59, 59)} // to 11:59 PM
                // scrollToTime={new Date(1970, 0, 1, 6, 0, 0)} // Auto scroll to 6:00 AM
                date={current}
                localizer={localizer}
                events={allEvents}
                formats={{
                  timeGutterFormat: (date, culture, localizer) =>
                    localizer.format(date, "HH:mm", culture),
                  selectRangeFormat: ({ start, end }, culture, localizer) =>
                    `${localizer.format(
                      start,
                      "HH:mm",
                      culture
                    )} — ${localizer.format(end, "HH:mm", culture)}`,
                }}
                dayPropGetter={(date) => {
                  if (isPastDate(date)) {
                    return {
                      style: {
                        backgroundColor: "#F8FAFC", // light grey
                        pointerEvents: "none", // disables all interactions
                        opacity: 0.8,
                      },
                    };
                  }
                  return {};
                }}
                startAccessor="start"
                endAccessor="end"
                selectable="ignoreEvents"
                onSelectSlot={handleSelectSlot}
                onEventResize={handleEventDrop}
                onEventDrop={handleEventDrop}
                resizable
                defaultView={Views.WEEK}
                views={[Views.WEEK]}
                eventPropGetter={eventStyleGetter}
                onNavigate={(date) => setCurrent(date)}
                components={{
                  toolbar: CustomToolbar,
                  event: EventComponent,
                  header: CustomDateHeader,
                  timeGutterHeader: () => (
                    <div
                      style={{
                        textAlign: "center",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                        width: "80px",
                        fontSize: "16px",
                        fontWeight: 500,
                        fontFamily: "Poppins",
                        color: "#171717",
                        border: "1px solid white",
                        margin: 0,
                      }}
                    ></div>
                  ),
                  timeGutterWrapper: ({ children }) => <div>{children}</div>,
                  timeSlotWrapper: ({ children }) => (
                    <div
                      style={{
                        textAlign: "center",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",

                        width: "80px !important",
                        fontSize: "12px",
                        fontWeight: 500,
                        fontFamily: "Poppins",
                        color: "#171717",
                      }}
                    >
                      {children}
                    </div>
                  ),
                }}
                className={cn(
                  mode === "availability"
                    ? "availability-calendar"
                    : "unavailability-calendar"
                )}
                style={{ height: 540 }}
              />
            )}
          </div>
        </DndProvider>
      </div>
      <div
        className="w-full lg:w-60 xl:w-64 flex-shrink-0 bg-white border-[1px] border-solid border-[#E2E8F0] shadow-sm h-min rounded-2xl lg:mt-1"
      >
        <div className=" rounded-2xl p-[12px]">
          <div className="flex items-center justify-between pb-3 mb-3 border-b-[1px] border-solid border-x-0 border-t-0 border-[#F1F5F9]">
            <div className="flex items-center gap-2">
              <div className="flex items-center justify-center w-[32px] h-[32px] rounded-lg bg-[#F0FDFA] text-[#0D9488] flex-shrink-0">
                <CalendarDays size={16} />
              </div>
              <span className=" text-[#171717] text-sm font-semibold font-poppins">
                Calendar view
              </span>
            </div>
            <span
              className="text-[#DC2626] bg-[#FEF2F2] hover:bg-[#FEE2E2] px-2.5 py-1 rounded-full text-[11px] font-poppins font-semibold cursor-pointer transition-colors"
              onClick={() => deleteAllScheduleConfirmation()}
            >
              Clear All
            </span>
          </div>
          <MiniCalendar
            current={current}
            setCurrent={setCurrent}
            setView={setView}
            data={data}
          />
          {/* <Checkbox
            value={sameForAllMonth}
            onChange={setSameForAllMonth}
            className="text-[#171717] text-[14px] font-normal mt-2 font-poppins"
          >
            Apply the same for all months
          </Checkbox> */}
        </div>
      </div>
      {showSlotDetails && selectedSlot && (
        <div
          ref={modalRef}
          className="absolute p-4 rounded-tr-[16px] rounded-br-[16px] rounded-bl-[16px] border-1 border-[#E2E8F0] z-50 bg-white"
          style={{
            left: `${clickPosition.x}px`,
            top: `${clickPosition.y}px`,
            boxShadow:
              "-4px -4px 20px rgba(75, 97, 255, 0.06), 4px 4px 20px rgba(75, 97, 255, 0.06)",
            transform: "scale(0.95)",
          }}
        >
          <SlotDetailsModal
            slot={selectedSlot}
            onSave={handleSaveSlot}
            onClose={() => {
              setShowSlotDetails(false);
              dispatch(resetCreateSlot());

              setHighlightedSlot(null);
            }}
            setSelectedSlot={setSelectedSlot}
            open={showSlotDetails}
            selectedDay={selectedDay}
            sameForAllWeek={sameForAllWeek}
            setSameForAllWeek={setSameForAllWeek}
          />
        </div>
      )}

      {editOpen && (
        <Popup
          isOpen={editOpen}
          onClose={setEditOpen}
          time={editMsg}
          editDialog={editDialog}
          setEditDialog={setEditDialog}
          setshowDeleteConfirmation={setshowDeleteConfirmation}
          editDate={editDate}
        />
      )}
      {showDeleteConfirmation && (
        <DeleteModel
          show={showDeleteConfirmation}
          setShow={(v) => {
            setshowDeleteConfirmation(v);
            dispatch(resetUpdateSlot());
          }}
          title={"Are you sure you want to delete this slot?"}
          description={""}
          icon={IMAGES.delete_unavailable}
          onDelete={() => {
            dispatch(deleteSchedule(editSlotId)).then(() => {
              dispatch(getSlots());
            });
          }}
        />
      )}
      {editDialog && (
        <div
          className="absolute p-4 rounded-tr-[16px] rounded-br-[16px] rounded-bl-[16px] border-1 border-[#E2E8F0] z-50 bg-white "
          style={{
            left: `${clickPosition.x}px`,
            top: `${clickPosition.y}px`,
            boxShadow:
              "-4px -4px 20px rgba(75, 97, 255, 0.06), 4px 4px 20px rgba(75, 97, 255, 0.06)",
          }}
        >
          <UpdateSlotDetailsModal
            slot={selectedSlot}
            updateSlot={setSelectedSlot}
            onSave={handleEditSlot}
            onClose={() => setEditDialog(false)}
            open={showSlotDetails}
            selectedDay={selectedDay}
            sameForAllWeek={sameForAllWeek}
            setEditDialog={setEditDialog}
            editSelectedDuration={editSelectedDuration}
            editSelectedModes={editSelectedModes}
            setSameForAllWeek={setSameForAllWeek}
          />
        </div>
      )}
      {show && (
        <Model
          show={show}
          setShow={(v) => {
            setShow(v);
            dispatch(resetUpdateSlot());
            dispatch(resetCreateSlot());
            dispatch(resetDeleteSchedule());
          }}
          title={title}
          description={description}
          icon={icon}
        />
      )}
      {deleteAllConfirmation && (
        <DeleteModel
          show={deleteAllConfirmation}
          setShow={(v) => {
            setDeleteAllConfirmation(false);
          }}
          title={title}
          description={"You may have appointment schedule"}
          icon={IMAGES.delete_unavailable}
          onDelete={() => {
            dispatch(deleteAllSchedule());
          }}
        />
      )}
    </div>
  );
}
